import React from "react";

export const ServingGlobal = () => {
  return (
      <section className="servingGlobal-component d-flex justify-content-center align-items-center">
        <div className="col-md-6 col-12">
        <div className="" data-aos="fade-down-right">
            <div className="flex-column container px-lg-5 p-2">
              <h2 className="text-white f-30-b text-center p-2 bg-secondary shadow-lg">
              Cultivating Your Best Self: Our Commitment to Success
              </h2>
              <p className="my-3 text-white f-18-b text-center">
              You deserve an extraordinary life, liberated from any constraints or limitations. Prepare to be amazed by the profound transformation awaiting you! Whether through Telehealth or in-person consultations, we're dedicated to supporting our patients every step of the way.
              </p>
            </div>
        </div>
        </div>
      </section>
  );
};
